import {Airnote} from '../../../afb-api/models/airnote';
import {TriggerEvent} from '../../../afb-api/models/trigger-event';

export class AwairNotifications {
  data: Array<Airnote | TriggerEvent>;
  pagination: Pagination;
}

export class PagedAwairGroupedNotifications {
  data: AwairGroupedNotification[];
  pagination: Pagination;
}

export class AwairGroupedNotification {
  date: string;
  notifications: Array<Airnote | TriggerEvent>;
}

export class Pagination {
  has_next: boolean;
  next_from: string;
}
